// src/pages/in-kind/DonateService.js
import InKindServiceForm from "../../components/InKindServiceForm";

function DonateService() {
  return <InKindServiceForm contributionType="donate" />;
}

export default DonateService;